/** @flow */

import {
  GetStandardQuestions,
  GetStandardQuestionsSuccess,
  GetStandardQuestionsError,
  NewStandardQuestion,
  SetShowAddStandardQuestionModal,
  UpdateStandardQuestionDraft,
  SetStandardQuestionRevisionSchema,
  SetStandardQuestionAssignments,
  GetStandardQuestion,
  GetStandardQuestionSuccess,
  GetStandardQuestionError,
  ShowStandardQuestionEditModal,
  StartStandardQuestionDraftSuccess,
  StartStandardQuestionDraftError,
  UpdateStandardQuestionAssignmentsError,
  ShowEditStandardQuestionAssignmentsModal,
  SetStandardQuestionDraftAssignments,
  UpdateStandardQuestion,
  UpdateStandardQuestionSuccess,
  UpdateStandardQuestionError,
  AddNewStandardQuestion,
  AddNewStandardQuestionSuccess,
  AddNewStandardQuestionError,
} from "@modules/service/constants/actions";
import * as standardQuestionsReducers from "./reducers";
import initialState from "./state";
import type { StandardQuestionsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: StandardQuestionsState = initialState,
  action: Object,
): StandardQuestionsState => {
  const act = {
    [AddNewStandardQuestion]: standardQuestionsReducers.onAddNewStandardQuestion,
    [AddNewStandardQuestionSuccess]: standardQuestionsReducers.onAddNewStandardQuestionSuccess,
    [AddNewStandardQuestionError]: standardQuestionsReducers.onAddNewStandardQuestionError,
    [UpdateStandardQuestion]: standardQuestionsReducers.onUpdateStandardQuestion,
    [UpdateStandardQuestionSuccess]: standardQuestionsReducers.onUpdateStandardQuestionSuccess,
    [UpdateStandardQuestionError]: standardQuestionsReducers.onUpdateStandardQuestionError,
    [GetStandardQuestions]: standardQuestionsReducers.onGetStandardQuestions,
    [GetStandardQuestionsSuccess]: standardQuestionsReducers.onGetStandardQuestionsSuccess,
    [GetStandardQuestionsError]: standardQuestionsReducers.onGetStandardQuestionsError,
    [GetStandardQuestionsSuccess]: standardQuestionsReducers.onGetStandardQuestionsSuccess,
    [GetStandardQuestionsError]: standardQuestionsReducers.onGetStandardQuestionsError,
    [NewStandardQuestion]: standardQuestionsReducers.onNewStandardQuestion,
    [SetShowAddStandardQuestionModal]: standardQuestionsReducers.onSetShowAddStandardQuestionModal,
    [UpdateStandardQuestionDraft]: standardQuestionsReducers.onUpdateStandardQuestionDraft,
    [SetStandardQuestionRevisionSchema]:
      standardQuestionsReducers.onSetStandardQuestionRevisionSchema,
    [SetStandardQuestionAssignments]: standardQuestionsReducers.onSetStandardQuestionAssignments,
    [SetStandardQuestionDraftAssignments]:
      standardQuestionsReducers.onSetStandardQuestionDraftAssignments,
    [GetStandardQuestion]: standardQuestionsReducers.onGetStandardQuestion,
    [GetStandardQuestionSuccess]: standardQuestionsReducers.onGetStandardQuestionSuccess,
    [GetStandardQuestionError]: standardQuestionsReducers.onGetStandardQuestionError,
    [ShowStandardQuestionEditModal]: standardQuestionsReducers.onShowStandardQuestionEditModal,
    [StartStandardQuestionDraftSuccess]:
      standardQuestionsReducers.onStartStandardQuestionDraftSuccess,
    [StartStandardQuestionDraftError]: standardQuestionsReducers.onStartStandardQuestionDraftError,
    [UpdateStandardQuestionAssignmentsError]:
      standardQuestionsReducers.onUpdateStandardQuestionAssignmentsError,
    [ShowEditStandardQuestionAssignmentsModal]:
      standardQuestionsReducers.onShowEditStandardQuestionAssignmentsModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
